import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CardSection, TextIcon } from '@europrocurement/flexy-components';
import { dateToFrenchFormat } from '@europrocurement/l2d-utils';
import EditablePriorityChip from '../../../../Dossiers/components/detail/EditablePriorityChip/EditablePriorityChip';
import InfoCardOrder from '../InfoCardOrder/InfoCardOrder';
import { useSelectedOrderContext } from '../../../providers';

export type OrderInformationsProps = {
    dateCreate?: string | number;
    dateUpdate?: string | number;
};

const OrderInformations: React.FunctionComponent<OrderInformationsProps> = function ({
    dateCreate,
    dateUpdate,
}) {
    const { palette, breakpoints } = useTheme();
    const { order, isUpdatingPriority, updateOrderPriority } = useSelectedOrderContext();

    const downMdBreakpoint = useMediaQuery(breakpoints.down('md'));

    const infosStyle = {
        display: 'grid',
        gridTemplateColumns: downMdBreakpoint ? '1fr' : 'repeat(4, 1fr)',
        gridTemplateRows: downMdBreakpoint ? 'repeat(2, 1fr)' : '1fr',
        marginTop: '16px',
        width: '100%',
    };
    const infoCardSx = {
        padding: downMdBreakpoint ? '16px 32px' : '8px 32px',
        borderRight: downMdBreakpoint ? 'none' : `solid 1px ${palette.grey[300]}`,
        '&:last-of-type': {
            borderRight: 'none',
        },
    };
    const textStyle = {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '19.2px',
        color: palette.grey[500],
    };

    const cardHeader = (
        <Box>
            <Typography variant="l2dh6">Traitement de la commande</Typography>
        </Box>
    );

    return (
        <CardSection
            header={cardHeader}
            sxHeader={{ padding: '24px 32px 8px 32px' }}
            sx={{ marginTop: '8px' }}
            sxContent={{ padding: '0 0 24px 0' }}
        >
            <Box sx={infosStyle}>
                <InfoCardOrder
                    label="Première création"
                    sx={infoCardSx}
                >
                    <TextIcon
                        icon={{ props: { icon: ['fasl', 'calendar'] } }}
                        gap="6px"
                    >
                        <Typography
                            sx={textStyle}
                            component="span"
                        >
                            {dateCreate ? dateToFrenchFormat(new Date(dateCreate)) : ' - '}
                        </Typography>
                    </TextIcon>
                </InfoCardOrder>
                <InfoCardOrder
                    label="Dernière mise à jour"
                    sx={infoCardSx}
                >
                    <TextIcon
                        icon={{ props: { icon: ['fasl', 'calendar'] } }}
                        gap="6px"
                    >
                        <Typography
                            sx={textStyle}
                            component="span"
                        >
                            {dateUpdate ? dateToFrenchFormat(new Date(dateUpdate)) : ' - '}
                        </Typography>
                    </TextIcon>
                </InfoCardOrder>
                <InfoCardOrder
                    label="Priorité "
                    sx={infoCardSx}
                >
                    <EditablePriorityChip
                        critical={order.urgent || false}
                        onPriorityChange={updateOrderPriority}
                        isLoading={isUpdatingPriority}
                        fontSx={{ fontSize: '13px' }}
                    />
                </InfoCardOrder>
            </Box>
        </CardSection>
    );
};

export default OrderInformations;
